import { Spin, Typography, Checkbox } from 'antd';
import { useAsync } from 'react-async-hook';
import providerService from 'services/providers.service';
import Html from 'Html';
import ScrollableTermsView from 'components/ScrollableTermsView/ScrollableTermsView';
import Card from 'components/Card/Card';

const { Paragraph } = Typography;

export const Agreement = ({ application }) => {
  const { result: agreements = [], loading } = useAsync(async () => {
    if (application?.id) {
      return await providerService.getApplicationAgreements(application.id);
    }

    return [];
  }, [application?.id]);

  return (
    <Spin spinning={loading}>
      <div className="flex flex-col gap-6">
        <Card>
          <div className="flex flex-col gap-8">
            {agreements.map(({ ula }) => (
              <ScrollableTermsView key={ula.id}>
                <div className="mb-6">
                  <p className="text-center uppercase text-lg font-medium mb-5">{ula.name}</p>
                  <Html html={ula.content} />
                </div>
              </ScrollableTermsView>
            ))}
          </div>

          {application?.agreementAcceptedDate && (
            <div className="mt-8 space-y-2 bg-gray-100 p-7 rounded-2xl">
              <Checkbox checked disabled className="mb-4">
                I acknowledge and agree to all terms in the above agreement.
              </Checkbox>

              <Paragraph className="mb-0">
                <b className="font-semibold">Accepted Date:</b> {application.agreementAcceptedDate}
              </Paragraph>

              {application?.agreementAcceptedBy && (
                <Paragraph className="mb-0">
                  <b className="font-semibold">Accepted By:</b> {application.agreementAcceptedBy}
                </Paragraph>
              )}
            </div>
          )}
        </Card>
      </div>
    </Spin>
  );
};

export default Agreement;
